import { render } from "./TheFavourites.vue?vue&type=template&id=142fa20b&scoped=true"
import script from "./TheFavourites.vue?vue&type=script&lang=js"
export * from "./TheFavourites.vue?vue&type=script&lang=js"

import "./TheFavourites.vue?vue&type=style&index=0&id=142fa20b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142fa20b"]])

export default __exports__